import * as React from 'react'
import { defineMessages, FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import styles from './faq.module.scss'

const messages = defineMessages({
  heading: {
    defaultMessage: 'Vanliga frågor och svar',
    id: 'diy-accounting.faq.heading',
  },
  question1: {
    defaultMessage: 'Fungerar Dooers bokföringsapp med alla företag?',
    id: 'diy-accounting.faq.question-1',
  },
  answer1: {
    defaultMessage: 'Dooer Bokföring fungerar enbart med aktiebolag.',
    id: 'diy-accounting.faq.answer-1',
  },
  question2: {
    defaultMessage: 'Är det svårt att byta till Dooers bokföringsapp?',
    id: 'diy-accounting.faq.question-2',
  },
  answer2: {
    defaultMessage:
      'Nej, det finns en guide i programmet för hur du kommer igång oavsett om det är ett nytt bolag eller om du vill flytta befintlig bokföring.',
    id: 'diy-accounting.faq.answer-2',
  },
  question3: {
    defaultMessage: 'Vad kostar det?',
    id: 'diy-accounting.faq.question-3',
  },
  answer3: {
    defaultMessage:
      'Dooers bokföringsapp för att bokföra själv är helt gratis att använda och kommer så alltid att vara.',
    id: 'diy-accounting.faq.answer-3',
  },
  question4: {
    defaultMessage: 'Vad skiljer Dooers bokföringsapp mot byrå-tjänsten?',
    id: 'diy-accounting.faq.question-4',
  },
  answer4: {
    defaultMessage:
      'Med vår bokföringsapp som är helt gratis är det du som gör all bokföring själv, det kräver att du har viss förståelse för bokföring och vilka regler som gäller. Med vår bokföringstjänst, som kostar från 895 kr per månad, får du en ekonom hos Dooer som gör hela din bokföring, svarar på frågor och ser till att allt blir rätt.',
    id: 'diy-accounting.faq.answer-4',
  },
})

const qas = [
  {
    q: messages.question1,
    a: messages.answer1,
  },
  {
    q: messages.question2,
    a: messages.answer2,
  },
  {
    q: messages.question3,
    a: messages.answer3,
  },
  {
    q: messages.question4,
    a: messages.answer4,
  },
]

export default function Faq() {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <FormattedHTMLMessage tagName="h2" {...messages.heading} />
        <div className={styles.items}>
          {qas.map((item) => (
            <div key={item.q.defaultMessage}>
              <FormattedMessage tagName="h4" {...item.q} />
              <FormattedMessage tagName="p" {...item.a} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
